import { render, staticRenderFns } from "./InspectionIncomingChildList.vue?vue&type=template&id=da36e5ba&scoped=true&"
import script from "./InspectionIncomingChildList.vue?vue&type=script&lang=js&"
export * from "./InspectionIncomingChildList.vue?vue&type=script&lang=js&"
import style0 from "./InspectionIncomingChildList.vue?vue&type=style&index=0&id=da36e5ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da36e5ba",
  null
  
)

export default component.exports